import * as types from '../actions/actionTypes';
import initialState from './initialState';        
        
export default function tipomonedaReducer(state= initialState.tipomoneda, action){
    let newState;
	switch(action.type){
         case types.LOAD_TIPOMONEDA_LIST_SUCCESS:		
            action.tipomoneda.filtroActivo=state.filtroActivo;
            action.tipomoneda.filtroActual=state.filtroActual;
            action.tipomoneda.showActivos=state.showActivos;
			 action.tipomoneda.paginaActual=action.tipomoneda.pageable.pageNumber;
			 action.tipomoneda.registrosPorPagina=action.tipomoneda.size;
            
            return action.tipomoneda;

        case types.BORRAR_TIPOMONEDA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(tipomoneda => tipomoneda.id !== action.tipomoneda.id)];          
			return newState;    
            
        case types.ACTIVAR_TIPOMONEDA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(tipomoneda => tipomoneda.id !== action.tipomoneda.id)];          
			 return newState;
            
        case types.SET_FILTRO_TIPOMONEDA:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}